import Request from './RequestHandler.js'

export default {
  getLead5Jobs (params) {
    return Request.make('get', 'leads', params)
  }
}
